<template>
  <v-container class="appDescriptionContainer">
      <v-layout >
        <v-flex>
          <div
            class="titleText"
            v-bind:class="{ hidden: !title}"
          >
            {{ title }}
          </div>
          <div
            class="subtitle"
            v-bind:class="{ hidden: !subtitle}"
          >
            {{ subtitle }}
          </div>
          <div
            class="description"
            v-bind:class="{ hidden: !text}"
          >
            {{ text }}
          </div>
        </v-flex>
      </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'TextBlock',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
  },
  data: () => ({
  }),
  mounted() {
  },
};
</script>

<style scoped>
.appDescriptionContainer {
  padding-top: 0px;
  padding-bottom: 0px;
}

.titleText {
  font-family: Gotham;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
}

.hidden {
  display: none;
}

.subtitle {
  font-family: Gotham;
  font-size: 16px;
  font-weight: bold;
  text-transform: capitalize;
  text-align: left;
  color: #000000;
  margin-bottom: 10px;
}

.description {
  font-family: Gotham;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  margin-bottom: 7px;
}

/* Mobile Break Point */
@media screen and (max-width: 767px) {
  .appDescriptionContainer {
    padding-top: 0px;
  }

  .description {
    margin-bottom: 25px;
  }
}

/* Mobile Break Point Larger */
@media screen and (min-width: 376px) and (max-width: 767px) {
  .description {
    margin-bottom: 0 !important;
  }
}
</style>
